/*
JTM - Cushion Fabric Yardage Calculator link and modal JS
*/


function initCushionFabricYardageCalculator() {

  function runWhenLoaded() {

    const loadedHtml = document.querySelector('html.q-is-loaded');

    if (!loadedHtml) {
      const loadedObserver = new MutationObserver(() => {
        const elm = document.querySelector('html.q-is-loaded');

        if (elm) {
          loadedObserver.disconnect();
          runWhenLoaded();
        }
      });

      loadedObserver.observe(document.documentElement, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'checked', 'id', 'disabled']
      });

      return;
    }

    const elm = loadedHtml; //.jquery-is-loaded

    if (document.querySelector("#calc-render")) {
  
      document.querySelector('#calcute')?.addEventListener('click', function (e) {

        e.preventDefault();

        /* if (document.querySelector('#finished_width').checkValidity() && document.querySelector('#finished_length').checkValidity() && document.querySelector('#thickness').checkValidity() && document.querySelector('#quantity').checkValidity() && document.querySelector('#fabric_width').checkValidity())
        { */
        if (document.querySelector('#finished_width').value !== "" && document.querySelector('#finished_length').value !== "" && document.querySelector('#thickness').value !== "" && document.querySelector('#quantity').value !== "" && document.querySelector('#fabric_width').value !== "") {

          edgeAllowance = 0.5;
          var finishedwidth = parseInt(document.querySelector("#finished_width").value);
          var finishedlength = parseInt(document.querySelector("#finished_length").value);
          var thickness = document.querySelector("#thickness").value;
          var quantity = document.querySelector("#quantity").value;
          var include = document.querySelector("input[type='radio'][name='box_include']:checked")?.value;
          var foamWidth = parseInt(finishedwidth) + edgeAllowance;
          var foamLength = parseInt(finishedlength) + edgeAllowance;
          var zipperSliderQty = quantity;
          var fabricWidth = parseInt(document.querySelector("#fabric_width").value);
          var orientation = document.querySelector('input[name="orientation"]:checked')?.value;

          document.querySelectorAll("#calc-render .show-after-submit").forEach(el => el.classList.remove("hide-me"));

          switch (include) {
            case "Full Cushion":
              var numOfPlates = parseInt(quantity) * 2;
              var plaqueLength = Math.round(parseInt(quantity) * (parseInt(finishedlength) + 2));
              var boxingWidth = parseInt(thickness) + edgeAllowance;
              var boxingLength = Math.round(((parseInt(quantity) * (((parseInt(finishedwidth) * 2) + parseInt(finishedlength)) + (4 * edgeAllowance))) * 1.05));
              var plaquewidth = boxingWidth + 1.25;
              var binding = Math.round((2 * (parseInt(quantity) * ((parseInt(finishedwidth) + parseInt(finishedlength)) * 2)) * 1.05));
              var StraightCutAdditionalFabric = Math.round(binding / parseInt(fabricWidth)) * 1.75;
              var bindingSource = Math.round(Math.sqrt(binding * 1.75) + 2);

              if (orientation == 'Width') {
                var howManyPlatesCanFit = Math.floor(parseInt(fabricWidth) / parseInt(finishedlength));

                if (howManyPlatesCanFit < 1) {
                  howManyPlatesCanFit = parseInt(fabricWidth) / parseInt(finishedlength);
                }

                var howManyPlateSections = Math.ceil(numOfPlates / howManyPlatesCanFit);
                var inchesNeeded = howManyPlateSections * parseInt(finishedwidth);
              } else {
                var howManyPlatesCanFit = Math.floor(parseInt(fabricWidth) / parseInt(finishedwidth));

                if (howManyPlatesCanFit < 1) {
                  howManyPlatesCanFit = parseInt(fabricWidth) / parseInt(finishedwidth);
                }

                var howManyPlateSections = Math.ceil(numOfPlates / howManyPlatesCanFit);
                var inchesNeeded = howManyPlateSections * parseInt(finishedlength); // Plates
              }

              // console.log(inchesNeeded);
              inchesPlate = inchesNeeded;
              inchesNeeded += Math.ceil(plaqueLength / parseInt(fabricWidth)) * plaquewidth; // +Plaque
              // console.log(inchesNeeded);
              inchesPlaque = inchesNeeded;
              inchesNeeded += Math.ceil(boxingLength / parseInt(fabricWidth)) * boxingWidth; // +Boxing
              // console.log(inchesNeeded);
              inchesBoxing = inchesNeeded;

              break;

            case "One Plate & Boxing":
              var numOfPlates = parseInt(quantity) * 1;
              var plaqueLength = Math.round(parseInt(quantity) * (parseInt(finishedlength) + 1.25));
              var boxingWidth = parseInt(thickness) + edgeAllowance;
              var boxingLength = Math.round(((parseInt(quantity) * (((parseInt(finishedwidth) * 2) + parseInt(finishedlength)) + (4 * edgeAllowance))) * 1.05));
              var plaquewidth = boxingWidth + 1.25;
              var binding = (1 * (parseInt(quantity) * ((parseInt(finishedwidth) + parseInt(finishedlength)) * 2)) * 1.05);
              var StraightCutAdditionalFabric = Math.round(binding / parseInt(fabricWidth)) * 1.75;
              var bindingSource = Math.round(Math.sqrt(binding * 1.75) + 2);

              if (orientation == 'Width') {
                var howManyPlatesCanFit = Math.floor(parseInt(fabricWidth) / parseInt(finishedlength));

                if (howManyPlatesCanFit < 1) {
                  howManyPlatesCanFit = parseInt(fabricWidth) / parseInt(finishedlength);
                }

                var howManyPlateSections = Math.ceil(numOfPlates / howManyPlatesCanFit);
                var inchesNeeded = howManyPlateSections * parseInt(finishedwidth);
              } else {
                var howManyPlatesCanFit = Math.floor(parseInt(fabricWidth) / parseInt(finishedwidth));

                if (howManyPlatesCanFit < 1) {
                  howManyPlatesCanFit = parseInt(fabricWidth) / parseInt(finishedwidth);
                }

                var howManyPlateSections = Math.ceil(numOfPlates / howManyPlatesCanFit);
                var inchesNeeded = howManyPlateSections * parseInt(finishedlength); // Plates
              }

              inchesPlate = inchesNeeded;
              inchesNeeded += Math.ceil(plaqueLength / parseInt(fabricWidth)) * plaquewidth; // +Plaque
              inchesPlaque = inchesNeeded;
              inchesNeeded += Math.ceil(boxingLength / parseInt(fabricWidth)) * boxingWidth; // +Boxing
              inchesBoxing = inchesNeeded;

              break;
          }

          if (numOfPlates === 1) {
            var plates = " plate";
          } else {
            var plates = " plates";
          }

          var totalPlate = numOfPlates + plates;

          document.querySelector("#zipperSliderQty").textContent = zipperSliderQty;
          document.querySelector("#plaqueLength").textContent = plaqueLength;
          document.querySelector("#zipperlength").textContent = plaqueLength;
          document.querySelector("#boxingWidth").textContent = boxingWidth;
          document.querySelector("#boxingLength").textContent = boxingLength;
          document.querySelector("#plaquewidth").textContent = plaquewidth;
          document.querySelector("#foamWidth").textContent = foamWidth;
          document.querySelector("#plateWidth").textContent = foamWidth;
          document.querySelector("#foamLength").textContent = foamLength;
          document.querySelector("#plateLength").textContent = foamLength;
          document.querySelector("#binding").textContent = binding;
          document.querySelector("#bindingSource").textContent = bindingSource;
          document.querySelector("#totalPlate").textContent = totalPlate;
          document.querySelector("#StraightCutAdditionalFabric").textContent = StraightCutAdditionalFabric;
          document.querySelector("#neededyards").textContent = roundUpToNearest(inchesNeeded / 36);
          document.querySelector("#inchesPlate").textContent = inchesPlate;
          document.querySelector("#inchesPlaque").textContent = inchesPlaque;
          document.querySelector("#inchesBoxing").textContent = inchesBoxing;


          var pixel = 5;//10

          // lable
          // var renditionCanvas = document.getElementById("renditionLabel");
          // var ctx = renditionCanvas.getContext("2d");
          // ctx.fillStyle = "black";
          // ctx.font = "18pt Arial";
          // ctx.clearRect(0, 0, 310, 50);
          // ctx.fillText("Panel Rendition", 10, 25);

          document.querySelectorAll('.orange_section').forEach(el => el.remove());
          document.querySelectorAll('.blue_section').forEach(el => el.remove());
          document.querySelectorAll('.green_section').forEach(el => el.remove());
          document.querySelectorAll('.remaining_green_section').forEach(el => el.remove());
          document.querySelectorAll(".rendition-container").forEach(el => { el.style.width = `${fabricWidth * pixel}px`; });

          // document.querySelector('#greencontainer')?.classList.remove('flexbox');

          //green
          switch (include) {
            case "Full Cushion":

              if (orientation == "Width") {

                if ((finishedlength < fabricWidth && finishedwidth < fabricWidth) || (finishedlength < fabricWidth && finishedwidth == fabricWidth)) {

                  // alert(" < < full width");
                  for (var g = 1; g <= numOfPlates; g++) {
                    document.querySelector("#greencontainer").insertAdjacentHTML("beforeend", "<div class='green_section'>Cut 1 plate " + foamLength + " X " + foamWidth + "</div>");
                    document.querySelectorAll(".green_section").forEach(el => { el.style.width = `${foamLength * pixel}px`; el.style.height = `${foamWidth * pixel}px`; });
                  }

                } else if ((finishedlength > fabricWidth && finishedwidth < fabricWidth) || (finishedlength > fabricWidth && finishedwidth == fabricWidth)) {

                  // alert(" > < full width");
                  var greensection = Math.ceil(finishedlength / fabricWidth);
                  var totalgreensection = greensection * numOfPlates;

                  for (var g = 1; g <= numOfPlates; g++) {
                    document.querySelector("#greencontainer").insertAdjacentHTML("beforeend", "<div class='green_section'>Cut 1 plate " + fabricWidth + " X " + foamWidth + "</div>");
                    document.querySelectorAll(".green_section").forEach(el => { el.style.width = `${fabricWidth * pixel}px`; el.style.height = `${foamWidth * pixel}px`; });
                  }

                  var greenRemainWidth = foamLength - fabricWidth;

                  for (var g = 1; g <= numOfPlates; g++) {
                    document.querySelector("#greencontainer").insertAdjacentHTML("beforeend", "<div class='remaining_green_section'>Cut remainders to " + greenRemainWidth + " X " + foamWidth + "</div>");
                    document.querySelectorAll(".remaining_green_section").forEach(el => { el.style.width = `${greenRemainWidth * pixel}px`; el.style.height = `${foamWidth * pixel}px`; });
                  }

                } else if (finishedlength < fabricWidth && finishedwidth > fabricWidth) {

                  // alert(" < > full width");
                  for (var g = 1; g <= numOfPlates; g++) {
                    document.querySelector("#greencontainer").insertAdjacentHTML("beforeend", "<div class='green_section'>Cut 1 plate " + foamLength + " X " + foamWidth + "</div>");
                    document.querySelectorAll(".green_section").forEach(el => { el.style.width = `${foamLength * pixel}px`; el.style.height = `${foamWidth * pixel}px`; });
                  }

                } else if ((finishedlength > fabricWidth && finishedwidth > fabricWidth) || (finishedlength == fabricWidth && finishedwidth < fabricWidth) || (finishedlength == fabricWidth && finishedwidth > fabricWidth)) {

                  // alert(" > > full width");
                  for (var g = 1; g <= numOfPlates; g++) {
                    document.querySelector("#greencontainer").insertAdjacentHTML("beforeend", "<div class='green_section'>Cut 1 plate " + fabricWidth + " X " + foamWidth + "</div>");
                    document.querySelectorAll(".green_section").forEach(el => { el.style.width = `${fabricWidth * pixel}px`; el.style.height = `${foamWidth * pixel}px`; });
                  }

                  var remainders = foamLength - fabricWidth;

                  for (var g = 1; g <= numOfPlates; g++) {
                    document.querySelector("#greencontainer").insertAdjacentHTML("beforeend", "<div class='remaining_green_section'>Cut remainders to " + remainders + " X " + foamWidth + "</div>");
                    document.querySelectorAll(".remaining_green_section").forEach(el => { el.style.width = `${remainders * pixel}px`; el.style.height = `${foamWidth * pixel}px`; });
                  }

                }

              } else {

                //full length
                if ((finishedlength < fabricWidth && finishedwidth < fabricWidth) || (finishedlength == fabricWidth && finishedwidth < fabricWidth)) {

                  // alert(" < < full length");
                  for (var g = 1; g <= numOfPlates; g++) {
                    document.querySelector("#greencontainer").insertAdjacentHTML("beforeend", "<div class='green_section'>Cut 1 plate " + foamWidth + " X " + foamLength + "</div>");
                    document.querySelectorAll(".green_section").forEach(el => { el.style.width = `${foamWidth * pixel}px`; el.style.height = `${foamLength * pixel}px`; });
                  }

                } else if (finishedlength > fabricWidth && finishedwidth < fabricWidth) {

                  // alert(" > < full length");
                  for (var g = 1; g <= numOfPlates; g++) {
                    document.querySelector("#greencontainer").insertAdjacentHTML("beforeend", "<div class='green_section'>Cut 1 plate " + foamWidth + " X " + foamLength + "</div>");
                    document.querySelectorAll(".green_section").forEach(el => { el.style.width = `${foamWidth * pixel}px`; el.style.height = `${foamLength * pixel}px`; });
                  }

                } else if ((finishedlength < fabricWidth && finishedwidth > fabricWidth) || (finishedlength == fabricWidth && finishedwidth > fabricWidth)) {

                  // alert(" < > full length");
                  for (var g = 1; g <= numOfPlates; g++) {
                    document.querySelector("#greencontainer").insertAdjacentHTML("beforeend", "<div class='green_section'>Cut 1 plate " + fabricWidth + " X " + foamLength + "</div>");
                    document.querySelectorAll(".green_section").forEach(el => { el.style.width = `${fabricWidth * pixel}px`; el.style.height = `${foamLength * pixel}px`; });
                  }

                  var remainderswidth = foamWidth - fabricWidth;

                  for (var g = 1; g <= numOfPlates; g++) {
                    document.querySelector("#greencontainer").insertAdjacentHTML("beforeend", "<div class='remaining_green_section'>Cut remainders to " + remainderswidth + " X " + foamLength + "</div>");
                    document.querySelectorAll(".remaining_green_section").forEach(el => { el.style.width = `${remainderswidth * pixel}px`; el.style.height = `${foamLength * pixel}px`; });
                  }

                } else if ((finishedlength > fabricWidth && finishedwidth > fabricWidth) || (finishedlength < fabricWidth && finishedwidth == fabricWidth) || (finishedlength > fabricWidth && finishedwidth == fabricWidth)) {

                  // alert(" > > full length");
                  for (var g = 1; g <= numOfPlates; g++) {
                    document.querySelector("#greencontainer").insertAdjacentHTML("beforeend", "<div class='green_section'>Cut 1 plate " + fabricWidth + " X " + foamLength + "</div>");
                    document.querySelectorAll(".green_section").forEach(el => { el.style.width = `${fabricWidth * pixel}px`; el.style.height = `${foamLength * pixel}px`; });
                  }

                  var remainders = foamWidth - fabricWidth;

                  for (var g = 1; g <= numOfPlates; g++) {
                    document.querySelector("#greencontainer").insertAdjacentHTML("beforeend", "<div class='remaining_green_section'>Cut remainders to " + remainders + " X " + foamLength + "</div>");
                    document.querySelectorAll(".remaining_green_section").forEach(el => { el.style.width = `${remainders * pixel}px`; el.style.height = `${foamLength * pixel}px`; });
                  }

                }
              }

              break;

            case "One Plate & Boxing":

              if (orientation == "Width") {

                if ((finishedlength < fabricWidth && finishedwidth < fabricWidth) || (finishedlength < fabricWidth && finishedwidth == fabricWidth)) {

                  // alert(" < < one width");
                  for (var g = 1; g <= numOfPlates; g++) {
                    document.querySelector("#greencontainer").insertAdjacentHTML("beforeend", "<div class='green_section'>Cut 1 plate " + foamLength + " X " + foamWidth + "</div>");
                    document.querySelectorAll(".green_section").forEach(el => { el.style.width = `${foamLength * pixel}px`; el.style.height = `${foamWidth * pixel}px`; });
                  }

                } else if ((finishedlength > fabricWidth && finishedwidth < fabricWidth) || (finishedlength > fabricWidth && finishedwidth == fabricWidth)) {

                  // alert(" > < one width");
                  var greensection = Math.ceil(finishedlength / fabricWidth);
                  var totalgreensection = greensection * numOfPlates;

                  for (var g = 1; g <= numOfPlates; g++) {
                    document.querySelector("#greencontainer").insertAdjacentHTML("beforeend", "<div class='green_section'>Cut 1 plate " + fabricWidth + " X " + foamWidth + "</div>");
                    document.querySelectorAll(".green_section").forEach(el => { el.style.width = `${fabricWidth * pixel}px`; el.style.height = `${foamWidth * pixel}px`; });
                  }

                  var greenRemainWidth = foamLength - fabricWidth;

                  for (var g = 1; g <= numOfPlates; g++) {
                    document.querySelector("#greencontainer").insertAdjacentHTML("beforeend", "<div class='remaining_green_section'>Cut remainders to " + greenRemainWidth + " X " + foamWidth + "</div>");
                    document.querySelectorAll(".remaining_green_section").forEach(el => { el.style.width = `${greenRemainWidth * pixel}px`; el.style.height = `${foamWidth * pixel}px`; });
                  }

                } else if (finishedlength < fabricWidth && finishedwidth > fabricWidth) {

                  // alert(" < > one width");
                  for (var g = 1; g <= numOfPlates; g++) {
                    document.querySelector("#greencontainer").insertAdjacentHTML("beforeend", "<div class='green_section'>Cut " + totalPlate + " " + foamLength + " X " + foamWidth + "</div>");
                    document.querySelectorAll(".green_section").forEach(el => { el.style.width = `${foamLength * pixel}px`; el.style.height = `${foamWidth * pixel}px`; });
                  }

                } else if ((finishedlength > fabricWidth && finishedwidth > fabricWidth) || (finishedlength == fabricWidth && finishedwidth < fabricWidth) || (finishedlength == fabricWidth && finishedwidth > fabricWidth)) {

                  // alert(" > > one width");
                  for (var g = 1; g <= numOfPlates; g++) {
                    document.querySelector("#greencontainer").insertAdjacentHTML("beforeend", "<div class='green_section'>Cut 1 plate " + fabricWidth + " X " + foamWidth + "</div>");
                    document.querySelectorAll(".green_section").forEach(el => { el.style.width = `${fabricWidth * pixel}px`; el.style.height = `${foamWidth * pixel}px`; });
                  }

                  var remainders = foamLength - fabricWidth;

                  for (var g = 1; g <= numOfPlates; g++) {
                    document.querySelector("#greencontainer").insertAdjacentHTML("beforeend", "<div class='remaining_green_section'>Cut remainders to " + remainders + " X " + foamWidth + "</div>");
                    document.querySelectorAll(".remaining_green_section").forEach(el => { el.style.width = `${remainders * pixel}px`; el.style.height = `${foamWidth * pixel}px`; });
                  }

                }

              } else {

                //one length
                if ((finishedlength < fabricWidth && finishedwidth < fabricWidth) || (finishedlength == fabricWidth && finishedwidth < fabricWidth)) {

                  // alert(" < < one length");
                  for (var g = 1; g <= numOfPlates; g++) {
                    document.querySelector("#greencontainer").insertAdjacentHTML("beforeend", "<div class='green_section'>Cut 1 plate " + foamWidth + " X " + foamLength + "</div>");
                    document.querySelectorAll(".green_section").forEach(el => { el.style.width = `${foamWidth * pixel}px`; el.style.height = `${foamLength * pixel}px`; });
                  }

                } else if (finishedlength > fabricWidth && finishedwidth < fabricWidth) {

                  // alert(" > < one length");
                  for (var g = 1; g <= numOfPlates; g++) {
                    document.querySelector("#greencontainer").insertAdjacentHTML("beforeend", "<div class='green_section'>Cut " + totalPlate + " " + foamWidth + " X " + foamLength + "</div>");
                    document.querySelectorAll(".green_section").forEach(el => { el.style.width = `${foamWidth * pixel}px`; el.style.height = `${foamLength * pixel}px`; });
                  }

                } else if ((finishedlength < fabricWidth && finishedwidth > fabricWidth) || (finishedlength < fabricWidth && finishedwidth == fabricWidth) || (finishedlength == fabricWidth && finishedwidth > fabricWidth)) {

                  // alert(" < > one length");
                  for (var g = 1; g <= numOfPlates; g++) {
                    document.querySelector("#greencontainer").insertAdjacentHTML("beforeend", "<div class='green_section'>Cut " + totalPlate + " " + fabricWidth + " X " + foamLength + "</div>");
                    document.querySelectorAll(".green_section").forEach(el => { el.style.width = `${fabricWidth * pixel}px`; el.style.height = `${foamLength * pixel}px`; });
                  }

                  var remainderswidth = foamWidth - fabricWidth;

                  for (var g = 1; g <= numOfPlates; g++) {
                    document.querySelector("#greencontainer").insertAdjacentHTML("beforeend", "<div class='remaining_green_section'>Cut remainders to " + remainderswidth + " X " + foamLength + "</div>");
                    document.querySelectorAll(".remaining_green_section").forEach(el => { el.style.width = `${remainderswidth * pixel}px`; el.style.height = `${foamLength * pixel}px`; });
                  }

                } else if ((finishedlength > fabricWidth && finishedwidth > fabricWidth) || (finishedlength > fabricWidth && finishedwidth == fabricWidth)) {

                  // alert(" > > one length");
                  for (var g = 1; g <= numOfPlates; g++) {
                    document.querySelector("#greencontainer").insertAdjacentHTML("beforeend", "<div class='green_section'>Cut 1 plate " + fabricWidth + " X " + foamLength + "</div>");
                    document.querySelectorAll(".green_section").forEach(el => { el.style.width = `${fabricWidth * pixel}px`; el.style.height = `${foamLength * pixel}px`; });
                  }

                  var remainders = foamWidth - fabricWidth;

                  for (var g = 1; g <= numOfPlates; g++) {
                    document.querySelector("#greencontainer").insertAdjacentHTML("beforeend", "<div class='remaining_green_section'>Cut remainders to " + remainders + " X " + foamLength + "</div>");
                    document.querySelectorAll(".remaining_green_section").forEach(el => { el.style.width = `${remainders * pixel}px`; el.style.height = `${foamLength * pixel}px`; });
                  }

                }
              }

              break;
          }

          //orange
          var orangesection = Math.ceil(boxingLength / fabricWidth);

          for (var o = 1; o <= orangesection; o++) {
            document.querySelector("#orangecontainer").insertAdjacentHTML("beforeend", "<div class='orange_section'>Boxing in orange " + boxingWidth + " wide</div>");
            document.querySelectorAll(".orange_section").forEach(el => { el.style.width = `${fabricWidth * pixel}px`; el.style.height = `${boxingWidth * pixel}px`; });
          }

          //blue
          var bluesection = Math.ceil(plaqueLength / fabricWidth);

          for (var b = 1; b <= bluesection; b++) {
            document.querySelector("#bluecontainer").insertAdjacentHTML("beforeend", "<div class='blue_section'>Plaque in blue " + plaquewidth + " wide</div>");
            document.querySelectorAll(".blue_section").forEach(el => { el.style.width = `${fabricWidth * pixel}px`; el.style.height = `${plaquewidth * pixel}px`; });
          }
        }

        // remove hash but causes extra history state
        //history.replaceState(null, null, ' ');
        //var url = window.location.url;
        //window.location.replace(url);

        return false;
      });

      function roundUpToNearest(elemValue,toNearest) {
      
        var newValue = null;

        if (elemValue !== null) {
          var originalValue = elemValue;

          if (elemValue.toString().charAt(0) == "0" && elemValue.length > 1) {
            return originalValue;
          }

          var changeValue = (Math.floor(1000 * elemValue) / 1000).toFixed(2);

          if (toNearest === undefined) {
            toNearest = 0.5;
          }

          var changeValue = Number((Math.ceil(elemValue / toNearest) * toNearest).toFixed(2));
          newValue = "";

          if (changeValue === 0.00) {
            newValue = originalValue;
          } else if (changeValue == 1.00) {
            newValue = originalValue;
          } else {
            newValue = changeValue;
          }
        }

        return newValue;
      }

      document.querySelectorAll('#calc-render .help').forEach(help => help.addEventListener('click', function (e) {

        e.preventDefault();

        var dataHelpID = this.closest(".calculator-input-wrapper")?.getAttribute("data-help-id");

        document.querySelectorAll("#calc-render .info_two").forEach(el => {
          if (!dataHelpID || !el.matches(dataHelpID)) el.style.display = "none";
        });

        if (dataHelpID) document.querySelector(dataHelpID)?.style.setProperty("display", "block");

        return false;
      }));

      document.querySelectorAll('#calc-render .help-close').forEach(helpClose => helpClose.addEventListener('click', function (e) {

        e.preventDefault();

        this.closest(".info_two")?.style.setProperty("display", "none");

        return false;
      }));

    } // end if #calc-render

  } // end wait for html.q-is-loaded

  runWhenLoaded();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCushionFabricYardageCalculator);
} else {
  initCushionFabricYardageCalculator();
} // end doc ready